import React from "react";
import BottomNav from "@/components/BottomNav";

// Light, premium mobile shell for the MELLETIC learning experience.
export default function AppShell({ children, nav = true, className = "", pad = true }) {
  return (
    <div className="min-h-screen w-full bg-[#0B1220] flex justify-center">
      <div
        className={`relative w-full max-w-[460px] min-h-screen bg-[#F8FAFC] flex flex-col ${nav ? "pb-24" : ""} ${className}`}
        style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
      >
        <div className={`flex-1 ${pad ? "px-5" : ""}`}>{children}</div>
        {nav && <BottomNav />}
      </div>
    </div>
  );
}
